// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2HOB_","buttons":"SendReceipts_buttons__2mrPE","email":"SendReceipts_email__2aofV","bookApptTitle":"SendReceipts_bookApptTitle__3h8cn"};